import * as AntdIcons from '@ant-design/icons';
import type { ComponentType } from 'react';
import { createGuardedComponent } from '../../provider/create-guarded-component';

function isReactElementType(value: unknown): value is ComponentType {
  return typeof value === 'object' && value !== null && '$$typeof' in value;
}

export const Icons = Object.fromEntries(
  Object.entries(AntdIcons).map(([key, value]) => [key, isReactElementType(value) ? createGuardedComponent(value) : value])
) as typeof AntdIcons;
